/* src/routes/blog/unity3d-animation-from-transform.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import Prism from "../../../_components/PrismJS.svelte.js";
import Callout from "../../../_components/Callout.svelte.js";
import Vimeo from "../../../_components/Vimeo.svelte.js";
import Gallery from "../../../_components/Gallery.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";

function create_default_slot_8(ctx) {
	let t;

	return {
		c() {
			t = text("In the above example the only thing being manipulated is the objects\n    position and rotation (The animations are happening automagically)");
		},
		l(nodes) {
			t = claim_text(nodes, "In the above example the only thing being manipulated is the objects\n    position and rotation (The animations are happening automagically)");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (41:2) <PostSection title="How to">
function create_default_slot_7(ctx) {
	let t0;
	let strong;
	let t1;
	let t2;

	return {
		c() {
			t0 = text("First we need to load a Mecanim\n    ");
			strong = element("strong");
			t1 = text("Animator->Controller");
			t2 = text("\n    and a model to attach an Animator component onto.");
		},
		l(nodes) {
			t0 = claim_text(nodes, "First we need to load a Mecanim\n    ");
			strong = claim_element(nodes, "STRONG", {});
			var strong_nodes = children(strong);
			t1 = claim_text(strong_nodes, "Animator->Controller");
			strong_nodes.forEach(detach);
			t2 = claim_text(nodes, "\n    and a model to attach an Animator component onto.");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, strong, anchor);
			append(strong, t1);
			insert(target, t2, anchor);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(strong);
			if (detaching) detach(t2);
		}
	};
}

// (57:2) <PostSection title="Animation States and Variables">
function create_default_slot_6(ctx) {
	let t;

	return {
		c() {
			t = text("We can see that there are a few states and variables included in this\n    controller.");
		},
		l(nodes) {
			t = claim_text(nodes, "We can see that there are a few states and variables included in this\n    controller.");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (72:2) <PostSection title="The Code">
function create_default_slot_5(ctx) {
	let prism;
	let current;

	prism = new Prism({
			props: {
				language: "csharp",
				code: /*gistContents*/ ctx[0]
			}
		});

	return {
		c() {
			create_component(prism.$$.fragment);
		},
		l(nodes) {
			claim_component(prism.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(prism, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const prism_changes = {};
			if (dirty & /*gistContents*/ 1) prism_changes.code = /*gistContents*/ ctx[0];
			prism.$set(prism_changes);
		},
		i(local) {
			if (current) return;
			transition_in(prism.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(prism.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(prism, detaching);
		}
	};
}

// (84:4) <Callout title="Velocity">
function create_default_slot_4(ctx) {
	let t;

	return {
		c() {
			t = text("This is the difference between this frames transform and the previous\n      frames transform.");
		},
		l(nodes) {
			t = claim_text(nodes, "This is the difference between this frames transform and the previous\n      frames transform.");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (89:4) <Callout title="Note">
function create_default_slot_3(ctx) {
	let strong;
	let t0;
	let t1;

	return {
		c() {
			strong = element("strong");
			t0 = text("MinMovementAmount");
			t1 = text("\n      - This variable can be changed in order to get the desired effect. I found\n      that a value of 1 produced good movements for the prototype I was\n      implementing.");
		},
		l(nodes) {
			strong = claim_element(nodes, "STRONG", {});
			var strong_nodes = children(strong);
			t0 = claim_text(strong_nodes, "MinMovementAmount");
			strong_nodes.forEach(detach);
			t1 = claim_text(nodes, "\n      - This variable can be changed in order to get the desired effect. I found\n      that a value of 1 produced good movements for the prototype I was\n      implementing.");
		},
		m(target, anchor) {
			insert(target, strong, anchor);
			append(strong, t0);
			insert(target, t1, anchor);
		},
		d(detaching) {
			if (detaching) detach(strong);
			if (detaching) detach(t1);
		}
	};
}

// (77:2) <PostSection title="Explanation">
function create_default_slot_2(ctx) {
	let t0;
	let strong0;
	let t1;
	let t2;
	let strong1;
	let t3;
	let t4;
	let callout0;
	let t5;
	let callout1;
	let current;

	callout0 = new Callout({
			props: {
				title: "Velocity",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	callout1 = new Callout({
			props: {
				title: "Note",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("Each Update() the\n    ");
			strong0 = element("strong");
			t1 = text("Velocity");
			t2 = text("\n    (Vector3) of the object is taken . This value is then passed to the animator\n    (if one exists) which sets the specified movement float (\"\n    ");
			strong1 = element("strong");
			t3 = text("Forward");
			t4 = text("\n    \" in my example)\n    ");
			create_component(callout0.$$.fragment);
			t5 = space();
			create_component(callout1.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "Each Update() the\n    ");
			strong0 = claim_element(nodes, "STRONG", {});
			var strong0_nodes = children(strong0);
			t1 = claim_text(strong0_nodes, "Velocity");
			strong0_nodes.forEach(detach);
			t2 = claim_text(nodes, "\n    (Vector3) of the object is taken . This value is then passed to the animator\n    (if one exists) which sets the specified movement float (\"\n    ");
			strong1 = claim_element(nodes, "STRONG", {});
			var strong1_nodes = children(strong1);
			t3 = claim_text(strong1_nodes, "Forward");
			strong1_nodes.forEach(detach);
			t4 = claim_text(nodes, "\n    \" in my example)\n    ");
			claim_component(callout0.$$.fragment, nodes);
			t5 = claim_space(nodes);
			claim_component(callout1.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, strong0, anchor);
			append(strong0, t1);
			insert(target, t2, anchor);
			insert(target, strong1, anchor);
			append(strong1, t3);
			insert(target, t4, anchor);
			mount_component(callout0, target, anchor);
			insert(target, t5, anchor);
			mount_component(callout1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const callout0_changes = {};

			if (dirty & /*$$scope*/ 8) {
				callout0_changes.$$scope = { dirty, ctx };
			}

			callout0.$set(callout0_changes);
			const callout1_changes = {};

			if (dirty & /*$$scope*/ 8) {
				callout1_changes.$$scope = { dirty, ctx };
			}

			callout1.$set(callout1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(callout0.$$.fragment, local);
			transition_in(callout1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(callout0.$$.fragment, local);
			transition_out(callout1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(strong0);
			if (detaching) detach(t2);
			if (detaching) detach(strong1);
			if (detaching) detach(t4);
			destroy_component(callout0, detaching);
			if (detaching) detach(t5);
			destroy_component(callout1, detaching);
		}
	};
}

// (97:2) <PostSection title="Usage">
function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("Simply attach this script to your object that contains your character. Good\n    luck, let me know in the comments if anything needs explaining or if this\n    does not work for you :)");
		},
		l(nodes) {
			t = claim_text(nodes, "Simply attach this script to your object that contains your character. Good\n    luck, let me know in the comments if anything needs explaining or if this\n    does not work for you :)");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (30:0) <PostContents>
function create_default_slot(ctx) {
	let t0;
	let vimeo;
	let t1;
	let callout;
	let t2;
	let postsection0;
	let t3;
	let strong0;
	let t4;
	let t5;
	let strong1;
	let t6;
	let t7;
	let br0;
	let t8;
	let gallery0;
	let t9;
	let br1;
	let t10;
	let postsection1;
	let t11;
	let strong2;
	let t12;
	let t13;
	let br2;
	let t14;
	let gallery1;
	let t15;
	let br3;
	let t16;
	let strong3;
	let t17;
	let t18;
	let postsection2;
	let t19;
	let postsection3;
	let t20;
	let postsection4;
	let current;
	vimeo = new Vimeo({ props: { id: "187484099" } });

	callout = new Callout({
			props: {
				title: "Position and Rotation only",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	postsection0 = new PostSection({
			props: {
				title: "How to",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	gallery0 = new Gallery({
			props: {
				useThumbnail: false,
				images: [
					"/content/blog/images/unity3d-animation-from-transform/Standard_asset_Animator_Robot_kyle.png"
				]
			}
		});

	postsection1 = new PostSection({
			props: {
				title: "Animation States and Variables",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	gallery1 = new Gallery({
			props: {
				useThumbnail: false,
				images: [
					"/content/blog/images/unity3d-animation-from-transform/ThirdPersonAnimatorController.png"
				]
			}
		});

	postsection2 = new PostSection({
			props: {
				title: "The Code",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	postsection3 = new PostSection({
			props: {
				title: "Explanation",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	postsection4 = new PostSection({
			props: {
				title: "Usage",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("In this post I will try to explain how I implemented simple auto animation for\n  my characters based on their changing position in the scene (using mecanim and\n  a simple script).\n  ");
			create_component(vimeo.$$.fragment);
			t1 = space();
			create_component(callout.$$.fragment);
			t2 = space();
			create_component(postsection0.$$.fragment);
			t3 = text("\n  In my example I have used the classic unity model of\n  ");
			strong0 = element("strong");
			t4 = text("Kyle the Robot");
			t5 = text("\n  and the standard\n  ");
			strong1 = element("strong");
			t6 = text("ThirdPersonAnimatorController");
			t7 = text("\n  (Any model and controller will do).\n  ");
			br0 = element("br");
			t8 = space();
			create_component(gallery0.$$.fragment);
			t9 = space();
			br1 = element("br");
			t10 = space();
			create_component(postsection1.$$.fragment);
			t11 = text("\n  The variable we are interested in is\n  ");
			strong2 = element("strong");
			t12 = text("Forward");
			t13 = text("\n  .\n  ");
			br2 = element("br");
			t14 = space();
			create_component(gallery1.$$.fragment);
			t15 = space();
			br3 = element("br");
			t16 = text("\n  The value of\n  ");
			strong3 = element("strong");
			t17 = text("Forward");
			t18 = text("\n  will determine the walk/run animation that mecanim wil animate for us.\n  ");
			create_component(postsection2.$$.fragment);
			t19 = space();
			create_component(postsection3.$$.fragment);
			t20 = space();
			create_component(postsection4.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "In this post I will try to explain how I implemented simple auto animation for\n  my characters based on their changing position in the scene (using mecanim and\n  a simple script).\n  ");
			claim_component(vimeo.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(callout.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(postsection0.$$.fragment, nodes);
			t3 = claim_text(nodes, "\n  In my example I have used the classic unity model of\n  ");
			strong0 = claim_element(nodes, "STRONG", {});
			var strong0_nodes = children(strong0);
			t4 = claim_text(strong0_nodes, "Kyle the Robot");
			strong0_nodes.forEach(detach);
			t5 = claim_text(nodes, "\n  and the standard\n  ");
			strong1 = claim_element(nodes, "STRONG", {});
			var strong1_nodes = children(strong1);
			t6 = claim_text(strong1_nodes, "ThirdPersonAnimatorController");
			strong1_nodes.forEach(detach);
			t7 = claim_text(nodes, "\n  (Any model and controller will do).\n  ");
			br0 = claim_element(nodes, "BR", {});
			t8 = claim_space(nodes);
			claim_component(gallery0.$$.fragment, nodes);
			t9 = claim_space(nodes);
			br1 = claim_element(nodes, "BR", {});
			t10 = claim_space(nodes);
			claim_component(postsection1.$$.fragment, nodes);
			t11 = claim_text(nodes, "\n  The variable we are interested in is\n  ");
			strong2 = claim_element(nodes, "STRONG", {});
			var strong2_nodes = children(strong2);
			t12 = claim_text(strong2_nodes, "Forward");
			strong2_nodes.forEach(detach);
			t13 = claim_text(nodes, "\n  .\n  ");
			br2 = claim_element(nodes, "BR", {});
			t14 = claim_space(nodes);
			claim_component(gallery1.$$.fragment, nodes);
			t15 = claim_space(nodes);
			br3 = claim_element(nodes, "BR", {});
			t16 = claim_text(nodes, "\n  The value of\n  ");
			strong3 = claim_element(nodes, "STRONG", {});
			var strong3_nodes = children(strong3);
			t17 = claim_text(strong3_nodes, "Forward");
			strong3_nodes.forEach(detach);
			t18 = claim_text(nodes, "\n  will determine the walk/run animation that mecanim wil animate for us.\n  ");
			claim_component(postsection2.$$.fragment, nodes);
			t19 = claim_space(nodes);
			claim_component(postsection3.$$.fragment, nodes);
			t20 = claim_space(nodes);
			claim_component(postsection4.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(vimeo, target, anchor);
			insert(target, t1, anchor);
			mount_component(callout, target, anchor);
			insert(target, t2, anchor);
			mount_component(postsection0, target, anchor);
			insert(target, t3, anchor);
			insert(target, strong0, anchor);
			append(strong0, t4);
			insert(target, t5, anchor);
			insert(target, strong1, anchor);
			append(strong1, t6);
			insert(target, t7, anchor);
			insert(target, br0, anchor);
			insert(target, t8, anchor);
			mount_component(gallery0, target, anchor);
			insert(target, t9, anchor);
			insert(target, br1, anchor);
			insert(target, t10, anchor);
			mount_component(postsection1, target, anchor);
			insert(target, t11, anchor);
			insert(target, strong2, anchor);
			append(strong2, t12);
			insert(target, t13, anchor);
			insert(target, br2, anchor);
			insert(target, t14, anchor);
			mount_component(gallery1, target, anchor);
			insert(target, t15, anchor);
			insert(target, br3, anchor);
			insert(target, t16, anchor);
			insert(target, strong3, anchor);
			append(strong3, t17);
			insert(target, t18, anchor);
			mount_component(postsection2, target, anchor);
			insert(target, t19, anchor);
			mount_component(postsection3, target, anchor);
			insert(target, t20, anchor);
			mount_component(postsection4, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const callout_changes = {};

			if (dirty & /*$$scope*/ 8) {
				callout_changes.$$scope = { dirty, ctx };
			}

			callout.$set(callout_changes);
			const postsection0_changes = {};

			if (dirty & /*$$scope*/ 8) {
				postsection0_changes.$$scope = { dirty, ctx };
			}

			postsection0.$set(postsection0_changes);
			const postsection1_changes = {};

			if (dirty & /*$$scope*/ 8) {
				postsection1_changes.$$scope = { dirty, ctx };
			}

			postsection1.$set(postsection1_changes);
			const postsection2_changes = {};

			if (dirty & /*$$scope, gistContents*/ 9) {
				postsection2_changes.$$scope = { dirty, ctx };
			}

			postsection2.$set(postsection2_changes);
			const postsection3_changes = {};

			if (dirty & /*$$scope*/ 8) {
				postsection3_changes.$$scope = { dirty, ctx };
			}

			postsection3.$set(postsection3_changes);
			const postsection4_changes = {};

			if (dirty & /*$$scope*/ 8) {
				postsection4_changes.$$scope = { dirty, ctx };
			}

			postsection4.$set(postsection4_changes);
		},
		i(local) {
			if (current) return;
			transition_in(vimeo.$$.fragment, local);
			transition_in(callout.$$.fragment, local);
			transition_in(postsection0.$$.fragment, local);
			transition_in(gallery0.$$.fragment, local);
			transition_in(postsection1.$$.fragment, local);
			transition_in(gallery1.$$.fragment, local);
			transition_in(postsection2.$$.fragment, local);
			transition_in(postsection3.$$.fragment, local);
			transition_in(postsection4.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(vimeo.$$.fragment, local);
			transition_out(callout.$$.fragment, local);
			transition_out(postsection0.$$.fragment, local);
			transition_out(gallery0.$$.fragment, local);
			transition_out(postsection1.$$.fragment, local);
			transition_out(gallery1.$$.fragment, local);
			transition_out(postsection2.$$.fragment, local);
			transition_out(postsection3.$$.fragment, local);
			transition_out(postsection4.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(vimeo, detaching);
			if (detaching) detach(t1);
			destroy_component(callout, detaching);
			if (detaching) detach(t2);
			destroy_component(postsection0, detaching);
			if (detaching) detach(t3);
			if (detaching) detach(strong0);
			if (detaching) detach(t5);
			if (detaching) detach(strong1);
			if (detaching) detach(t7);
			if (detaching) detach(br0);
			if (detaching) detach(t8);
			destroy_component(gallery0, detaching);
			if (detaching) detach(t9);
			if (detaching) detach(br1);
			if (detaching) detach(t10);
			destroy_component(postsection1, detaching);
			if (detaching) detach(t11);
			if (detaching) detach(strong2);
			if (detaching) detach(t13);
			if (detaching) detach(br2);
			if (detaching) detach(t14);
			destroy_component(gallery1, detaching);
			if (detaching) detach(t15);
			if (detaching) detach(br3);
			if (detaching) detach(t16);
			if (detaching) detach(strong3);
			if (detaching) detach(t18);
			destroy_component(postsection2, detaching);
			if (detaching) detach(t19);
			destroy_component(postsection3, detaching);
			if (detaching) detach(t20);
			destroy_component(postsection4, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[1],
				projects: /*projects*/ ctx[2]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope, gistContents*/ 9) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

async function preload({ params, query }) {
	var url = "https://gist.githubusercontent.com/Gaweph/4cc5359a43d724a534ddc6efc82cc58d/raw/a93809baf23738dba70d1f39295f0028ee3eb594/AnimationFromTransform.cs";
	let response = await this.fetch(url);
	let text = await response.text();
	let gistContents = text;
	return { gistContents };
}

const title = "Mecanim Animation From Transform";
const date = "2016-10-17 21:30:00";

function instance($$self, $$props, $$invalidate) {
	const tags = ["software", "unity3d"];
	const projects = [];
	let { gistContents } = $$props;

	$$self.$$set = $$props => {
		if ("gistContents" in $$props) $$invalidate(0, gistContents = $$props.gistContents);
	};

	return [gistContents, tags, projects];
}

class Unity3d_animation_from_transform extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { gistContents: 0 });
	}
}

export default Unity3d_animation_from_transform;
export { preload };
//# sourceMappingURL=unity3d-animation-from-transform.svelte.js.map
